const config = {}

config.users = ['ines', 'macarena', 'eugenia', 'claudia', 'carla', 'marioJr', 'marioSr', 'isabel', 'chumi', 'ana', 'otto', 'eva', 'olga', 'scott']

export default config